const wrapRootElement = require('./src/wrap-root-element').default

exports.wrapRootElement = wrapRootElement
